import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "text-base text-center"
};
const _hoisted_2 = {
  class: "font-bold"
};
const _hoisted_3 = {
  class: "font-bold"
};
import GridItem from "@/modules/club-grounds/components/GridItem.vue";
import { app } from "@/di";
import SlotUnlocker from "@/modules/club-grounds/services/SlotUnlocker";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'LockedSlot',
  props: {
    groundSlot: null
  },
  emits: ['update'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const configRepository = app.get(ConfigRepository);
    const price = computed(() => configRepository.get('clubGrounds.costs.unlock')(props.groundSlot));
    const unlockDuration = computed(() => configRepository.get('clubGrounds.durations.unlock')(props.groundSlot));
    const confirmDialog = ref(null);
    const message = useMessage();
    const unlock = () => {
      if (!props.groundSlot.unlockable) {
        return;
      }
      confirmDialog.value.confirm().then(async () => {
        if (!props.groundSlot.locked) {
          throw 'Ground slot is unlocked already.';
        }
        await app.get(SlotUnlocker).unlock(props.groundSlot);
        message.success(translator.t('club_ground_unlocked'));
        emit('update');
      });
    };
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(GridItem, {
        color: _ctx.ColorEnum.Slate,
        class: _normalizeClass({
          'opacity-40': !__props.groundSlot.unlockable
        }),
        onClick: unlock
      }, {
        default: _withCtx(() => [_createVNode(_component_Icon, {
          icon: _ctx.IconEnum.LockClosed24Regular,
          size: "3rem",
          class: "mb-1"
        }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$money(_unref(price))), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$duration(_unref(unlockDuration), 'days').humanize()), 1)])]),
        _: 1
      }, 8, ["color", "class"]), _createVNode(RichDialog, {
        ref_key: "confirmDialog",
        ref: confirmDialog,
        days: _unref(unlockDuration),
        price: _unref(price),
        "gate-type": _ctx.GateTypeEnum.BALANCE,
        "gate-value": _unref(price)
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sure_you_want_to_unlock_the_slot?')), 1)]),
        default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(_ctx.$t('you_will_be_able_to_chose_the_type_afterwards')), 1)]),
        _: 1
      }, 8, ["days", "price", "gate-type", "gate-value"])]);
    };
  }
});